// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import axios from "axios"
import { ApiUrls } from '../../utility/ApiUrls'
import GlobalVariable from '../../settings/global'
import { clarity } from 'react-microsoft-clarity'
import Cookies from 'universal-cookie'


const baseApiUrl = GlobalVariable.BASE_API_URL
const chunkSize = 1048576 * 10
let getUserCall = false
const myEncodeURIComponent = DefaultConfig().myEncodeURIComponent
const getToken = () => {
  const expiryTimestamp = localStorage.getItem('expiryTime')
  if (!expiryTimestamp) {
    return false
  }
  const now = new Date().getTime()
  if (now > parseInt(expiryTimestamp, 10)) {
    return false
  }
  return true
}

let callUiConfiguration = false
const count = 0

const getUserApiCall = () => {
  axios.get(`${GlobalVariable.hostpath}api/Common/GetUIConfiguration`)
    .then((res) => {
      const result = res.data
      callUiConfiguration = false
      if (result) {
        const data = result.data
        if (data) {
          const azureAdB2C = data.azureAdB2C
          //const merchantOne = data.merchantOne
          const JsScriptData = data.jsScriptData
          azureAdB2C['apiUrl'] = GlobalVariable.hostpath
          azureAdB2C['hostname'] = window.location.origin
          localStorage.setItem('azureAdB2C', JSON.stringify(azureAdB2C))
          // localStorage.setItem('merchantOne', JSON.stringify(merchantOne))
          localStorage.setItem('JsScriptData', JSON.stringify(JsScriptData))
          const expiryTimestamp = new Date().getTime() + (data.expiryTime * 60 * 1000)
          localStorage.setItem('expiryTime', expiryTimestamp)
          const localStorageToken = localStorage.getItem('token')
          axios.get(`${GlobalVariable.hostpath}api/User/GetUser`, {
            headers: { Authorization: `Bearer ${localStorageToken}` }
          }).then((res) => {
            const userData = res.data
            if (userData.success) {
              if (userData.data) {
                if (window.location.hostname !== 'localhost') {
                  const msClarityId = localStorage.getItem('JsScriptData') ? JSON.parse(localStorage.getItem('JsScriptData'))['msClarityId'] : ''
                  clarity.init(msClarityId)
                  clarity.identify('USER_ID', { userProperty: userData.data.email })
                  clarity.setTag('Email', userData.data.email)
                  clarity.consent()
                }
                if (userData.data.isResetPassword === true) {
                  toast(t => (<ToastMessage t={t} message={"Your password has been changed successfully. Please Login..."} status={"success"} />))
                  setTimeout(() => {
                    localStorage.clear()
                    window.location.reload()
                  }, 3000)
                } else {
                  const cookies = new Cookies()
                  cookies.set('CustomClaims', res.headers["x-set-cookie"], { path: '/' })
                  localStorage.setItem('userData', JSON.stringify(userData.data))
                }
              }
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
              localStorage.clear()
              window.location.reload()
            }
          }).catch((error) => {
            const errorresponse = error.response
            if (errorresponse) {
              const status = errorresponse.status
              if (status === 403 || status === 401) {
                localStorage.clear()
                window.location.reload()
              } else if (status === 406) {
                // setError(true)
                window.location.reload()
              } else if (status === 412) {
                const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                localStorage.clear()
                window.location.href = AzureB2CLogoutUrl
              } else if (status === 417 || status === 424) {
                if (count !== 2) {
                  setCount(count + 1)
                }
                if ((count + 1) === 3) {
                  const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                  localStorage.clear()
                  window.location.href = AzureB2CLogoutUrl
                }
              } else {
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                setTimeout(() => {
                  localStorage.clear()
                  window.location.reload()
                }, 2000)
              }
            }
          })
        }
      }
    }).catch((error) => {
      const errorresponse = error.response
      if (errorresponse) {
        const status = errorresponse.status
        if (status === 404) {
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
      }
    })
}


const apiCall = async (method, endpoint, data) => {

  const authAxios = DefaultConfig().authAxios
  const token = getToken()
  if (!token && !callUiConfiguration) {
    callUiConfiguration = true
    getUserApiCall()
  }
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {

        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } if (status === 400) {
            toast(t => (<ToastMessage t={t} message={errorresponse.data.message} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

export const getRefreshToken = createAsyncThunk("appCommonReducers/getRefreshToken", async () => {
  const method = 'get'
  const endpoint = `User/GetRefreshToken`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    localStorage.setItem("token", resultData.id_token)
    localStorage.setItem("refresh_token", resultData.refresh_token)
    getUserApiCall()
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllRoles = createAsyncThunk("appCommonReducers/getAllRoles", async () => {
  const method = 'get'
  const endpoint = ApiUrls.GetAllRoles
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})


// Get All Users
export const getAllUsers = createAsyncThunk("appCommonReducers/getAllUsers", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetAllUsers
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData.users ? resultData.users : []
    // const recCount = resultData.totalItems
    // const gridSize = resultData.pageSize
    const recCount = resultData.count
    const gridSize = data.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserDetailsbyEmail = createAsyncThunk("appCommonReducers/GetUserDetailsbyEmail", async (data) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUserDetailsbyEmail}`
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
  const data = rdata.data
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const getCountryStates = createAsyncThunk("appCommonReducers/getCountryStates", async () => {
  const method = 'get'
  const endpoint = ApiUrls.GetCountryStates
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const countrys = []
    resultData.forEach((element) => {
      countrys.push({ value: element.alpha3Code, label: element.name, states: element.states, id: element.id })
    })
    return {
      data: countrys,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const getActiveCompanies = createAsyncThunk("appCommonReducers/getActiveCompanies", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetActiveCompanies
  const data = obj
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const workordersDto = resultData.companiesList ? resultData.companiesList : []
    // const recCount = resultData.totalItems
    // const gridSize = resultData.pageSize
    const recCount = resultData.count
    const gridSize = data.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserCompanies = createAsyncThunk("appCommonReducers/GetUserCompanies", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetUserCompanies
  const data = obj
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const workordersDto = resultData.companiesList ? resultData.companiesList : []
    // const recCount = resultData.totalItems
    // const gridSize = resultData.pageSize
    const recCount = resultData.count
    const gridSize = data.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUsersBySharedCompanies = createAsyncThunk("appCommonReducers/GetUsersBySharedCompanies", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetUsersBySharedCompanies
  const data = obj
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const workordersDto = resultData.users ? resultData.users : []
    // const recCount = resultData.totalItems
    // const gridSize = resultData.pageSize
    const recCount = resultData.count
    const gridSize = data.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})


export const GetAgentDetails = createAsyncThunk("appCommonReducers/GetAgentDetails", async (name) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAgentDetails}?agent=${name.trim()}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

// Impersonate User 
export const ImpersonateUser = createAsyncThunk("appCommonReducers/ImpersonateUser", async (email) => {
  const method = 'post'
  const endpoint = ApiUrls.ImpersonateUser
  const data = {}
  data['email'] = email
  const resultData = await apiCall(method, endpoint, data)
  if (resultData?.userData?.userAgents) {
    return {
      data: resultData.userData.userAgents,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: false,
      tokenExp: false
    }
  }
})

// getallROles

//sending the email to customer 
export const UnlistedUser = createAsyncThunk("appCommonReducers/UnlistedUser", async (wdata) => {

  const method = 'post'
  const endpoint = `/${ApiUrls.UnlistedUser}`
  const data = wdata.data
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={resultData} status={"sucesss"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateUser = createAsyncThunk("appCommonReducers/CreateUser", async (wdata) => {

  const method = 'post'
  const endpoint = `${ApiUrls.CreateNewUser}`

  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={resultData} status={"sucesss"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateAddress = createAsyncThunk("appCommonReducers/CreateAddress", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateAddress}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={resultData} status={"sucesss"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateUser = createAsyncThunk("appCommonReducers/UpdateUser", async (wdata) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.UpdateUser}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})
export const UpateCompany = createAsyncThunk("appCommonReducers/UpdateCompany", async (wdata) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.UpateCompany}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateUserCompanyMappingById = createAsyncThunk("appCommonReducers/UpdateUserCompanyMappingById", async (wdata) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.UpdateUserCompanyMappingById}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserDetailsById = createAsyncThunk("appCommonReducers/GetUserDetailsById", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUserDetailsById}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateUserCompanyMapping = createAsyncThunk("appCommonReducers/CreateUserCompanyMapping", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateUserCompanyMapping}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const ImportCompany = createAsyncThunk("appCommonReducers/ImportCompany", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.ImportCompany}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateCompanyUserMapping = createAsyncThunk("appCommonReducers/CreateCompanyUserMapping", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateCompanyUserMapping}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserByEmail = createAsyncThunk("appCommonReducers/GetUserByEmail", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUserByEmail}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})


export const GetCompanyDetailsById = createAsyncThunk("appCommonReducers/GetCompanyDetailsById", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetCompanyDetailsById}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateUserAddress = createAsyncThunk("appCommonReducers/UpdateUserAddress", async (wdata) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.UpdateUserAddress}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetVessels = createAsyncThunk("appCommonReducers/GetVessels", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetVessels
  const data = obj
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const workordersDto = resultData.vessels ? resultData.vessels : []
    // const recCount = resultData.totalItems
    // const gridSize = resultData.pageSize
    const recCount = resultData.count
    const gridSize = data.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetVesselDetailsById = createAsyncThunk("appCommonReducers/GetVesselDetailsById", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetVesselDetailsById}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateVessel = createAsyncThunk("appCommonReducers/UpdateVessel", async (wdata) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.UpdateVessel}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateVesselUserMapping = createAsyncThunk("appCommonReducers/UpdateVesselUserMapping", async (wdata) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.UpdateVesselUserMapping}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateUserVesselMapping = createAsyncThunk("appCommonReducers/CreateUserVesselMapping", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateUserVesselMapping}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateVessel = createAsyncThunk("appCommonReducers/CreateVessel", async (wdata) => {

  const method = 'post'
  const endpoint = `${ApiUrls.CreateVessel}`

  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    toast(t => (<ToastMessage t={t} message={resultData} status={"sucesss"} />))
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const InviteUser = createAsyncThunk("appCommonReducers/Users/InviteUser", async (wdata) => {
  console.log(wdata, "111")
  const method = 'post'
  const endpoint = `${ApiUrls.InviteUser}`
  const data = wdata
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  }
})

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
  return displayMenuBool
})

export const getWoLoading = createAsyncThunk("appCommonReducers/getWoLoading", async (data) => {
  return data
})
export const getCompanyValue = createAsyncThunk("appCommonReducers/getCompanyValue", async (data) => {
  // console.log(data, 'data')
  return data
})
export const getClearStore = createAsyncThunk("appCommonReducers/getClearStore", async () => {
  return ''
})

export const getClearStoreData = createAsyncThunk("appCommonReducers/getClearStoreData", async () => {
  return ''
})

export const getClearFileData = createAsyncThunk("appCommonReducers/getClearFileData", async () => {
  return ''
})

export const removeneedinfodata = createAsyncThunk("appCommonReducers/removeneedinfodata", async () => {
  return ''
})

export const getFileExceed = createAsyncThunk("appCommonReducers/getFileExceed", async () => {
  return ''
})

export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    woCates: [],
    spinner1: false,
    enableAction: false,

    woData: [],
    spinner3: true,
    recCount: 0,
    gridSize: 0,

    getAccBalanceSpinner: true,
    getAccBalance: {},

    frbSpinner: true,
    getFRBData: [],
    getFRBReqData: [],
    frbAllGroups: [],
    frbAllRoles: [],
    frbVessels: [],
    frDetails: {},
    currentBillingPrefixLine2: "",
    currentBillingPrefixLine1: "",
    FrbBillinfoData: [],
    frbRoleSpinner: true,
    getFRBClientRoles: [],

    invoiceListSpinner: true,
    invoiceListByAgent: [],

    dloader: false,
    documentTypes: [],

    cloader: false,
    countryStates: [],
    woIData: null,
    spinner4: false,

    wloader: false,
    woIdData: null,

    woIdDocs: [],
    wdloader: false,

    fileData: {},
    uploadErrMsg: '',
    woType: '',
    stype: '',
    woTypeId: null,
    floader: true,


    tokenExp: false,

    invoiceData: {},
    ispinner: false,
    userDetailswithId: {},
    companyDetailswithId: {},
    vesselDetailswithId: {},
    woBool: false,

    fileStatus: '',
    fileExceed: false,

    bwloader: false,
    bwData: null,

    agentLoader: false,
    agentData: [],
    tabStop: false,
    selectedAgent: localStorage.getItem('agentObj') ? JSON.parse(localStorage.getItem('agentObj')) : {},
    cartItems: localStorage.getItem('addToCartItems') ? JSON.parse(localStorage.getItem('addToCartItems')) : [],
    customerEmail: localStorage.getItem('customerEmail'),
    invoiceDownloadStatus: [],
    loadingOpaqueSpinner: false,
    userAgents: [],
    displayMenuBool: false,
    contactDetals: [],
    userRoleData: [],
    usersData: null
  },
  reducers: {
    handleAddtoCart: (state, action) => {
      // console.log(action.payload)
      localStorage.setItem('addToCartItems', action.payload?.cartData)
      state.cartItems = localStorage.getItem('addToCartItems') ? JSON.parse(localStorage.getItem('addToCartItems')) : []
      if (action.payload?.addingStatus) {
        const toastMsg = action.payload?.addingStatus
        toast(t => (<ToastMessage t={t} message={toastMsg} status={"success"} />), {
          position: 'top-center'
        })
      }
    },
    paymentDetailsLoader: (state, action) => {
      if (action.payload) {
        state.wloader = action.payload
      }
    },
    handleCusEmailChange: (state, action) => {
      localStorage.setItem('customerEmail', action.payload)
      if (action.payload) {
        if (state.customerEmail !== action.payload) {
          localStorage.removeItem('addToCartItems')
          state.customerEmail = action.payload
          state.woData = []
          state.cartItems = []
        }
      } else {
        state.customerEmail = action.payload
        state.woData = []
        state.cartItems = []
        localStorage.removeItem('addToCartItems')
      }
    },
    loadingOpaqueSpinnerStatus: (state, action) => {
      state.loadingOpaqueSpinner = action.payload
    },
    handleEmptyUserAgents: (state, action) => {
      state.contactDetals = []
      state.userAgents = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getCompanyValue.fulfilled, (state, action) => {
        if (action.payload) {
          state.selectedAgent = action.payload
          state.cartItems = []
          localStorage.removeItem('addToCartItems')
        } else {
          state.cartItems = []
          state.selectedAgent = {}
          state.woData = []
          localStorage.removeItem('addToCartItems')
        }
      })

      .addCase(getAllUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      })

      .addCase(GetUsersBySharedCompanies.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      })

      .addCase(getCountryStates.fulfilled, (state, action) => {
        if (action.payload) {
          state.cloader = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.countryStates = action.payload.data
        }
      })

      .addCase(SaveUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })

      .addCase(GetUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userRoleData = action.payload.data
        }
      })

      .addCase(getActiveCompanies.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp

          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      })

      .addCase(GetUserCompanies.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp

          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      })
      .addCase(GetAgentDetails.fulfilled, (state, action) => {
        if (action.payload) {
          const companyData = action.payload
          if (companyData) {
            const sfCompanys = []
            if (companyData.length > 0) {
              companyData.forEach((item) => {
                if (item.customerNumber) {
                  sfCompanys.push({ value: item.customerNumber, label: `${item.customerName} ${item.customerNumber !== null ? `(${item.customerNumber})` : ''}`, name: item.customerName, agentId: item.customerNumber })
                }
              })
            }
          }
        }
      })

      .addCase(GetUserDetailsById.fulfilled, (state, action) => {
        if (action.payload) {
          state.userDetailswithId = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })

      .addCase(GetCompanyDetailsById.fulfilled, (state, action) => {
        if (action.payload) {
          state.companyDetailswithId = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })

      .addCase(GetVessels.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      })

      .addCase(GetVesselDetailsById.fulfilled, (state, action) => {
        if (action.payload) {
          state.vesselDetailswithId = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })

      .addCase(ImpersonateUser.fulfilled, (state, action) => {
        if (action.payload) {
          state.loadingOpaqueSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userAgents = action.payload.data
        }
      })

      .addCase(displayMenu.fulfilled, (state, action) => {
        state.displayMenuBool = action.payload
      })
      .addCase(getFileExceed.fulfilled, (state) => {
        state.fileExceed = false
      })
  }
})
export const { handleAddtoCart, handleCusEmailChange, loadingOpaqueSpinnerStatus, handleEmptyUserAgents, paymentDetailsLoader } = commonreducerSlice.actions
export default commonreducerSlice.reducer
